import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { toasterMessages } from '@messages/*';
import { ToastrService } from 'ngx-toastr';
import { LoginRegisterService } from '../login-register.service';

@Component({
  selector: 'app-developer-login',
  templateUrl: './developer-login.component.html',
  styleUrls: ['./developer-login.component.scss']
})

export class DeveloperLoginComponent implements OnInit {
  selectedTab = null;
  token: string;
  adminExists = true;
  existingAdminEmail: string;

  constructor(
    private router: Router,
    private toastr: ToastrService,
    private loginRegisterService: LoginRegisterService,
    private route: ActivatedRoute) {
    this.route.queryParams.subscribe(params => {
      this.token = params.token;
    });
  }

  ngOnInit() {
    this.isUserExist();
  }

  /** send login request */
  loginSumbit(loginFormvalues) {
    if (this.adminExists) {
      this.existingUserlogin(loginFormvalues);
    }
  }

  private existingUserlogin(loginFormvalues) {
    this.loginRegisterService.loginRequest(loginFormvalues).subscribe((response) => {
      this.router.navigateByUrl('welcome');
    }, (err) => {
      this.toastr.error(err?.error?.errors[0]?.error, 'Error');
    });
  }

  /** Check Candidate Exist or not */
  isUserExist() {
    if (this.token) {
      this.loginRegisterService.isAdminExist(this.token).subscribe((response) => {
        this.adminExists = response.adminExists;
        this.existingAdminEmail = response.email;
      }, (err) => {
        this.toastr.error(toasterMessages.developerIsUserExists, 'Error');
      });
    }
  }

  /** send signup request */
  onRegister(registerFormValues) {
    this.loginRegisterService.signUpRequest(registerFormValues).subscribe((response) => {
      this.selectedTab = 0;
      this.toastr.success(toasterMessages.RegisterSuccess);
    }, (err) => {
      this.toastr.error(err?.error?.errors[0]?.error, 'Error');
    });
  }

}
